var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThePageSkeleton',{staticClass:"page-login",attrs:{"scroll-y":"","content-flex":""}},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }